export const roles = {
  user: "",
  doctor: "USER_ROL_PROFESSIONAL"
}